/**
 * @module api/publicApi/publicAgentApi
 */

import secureClient from 'lib/secure-client';
import apiUrl from 'shared_js/helpers/urlHelper/apiUrl';

/**
 * Retrieve User's Agent
 *
 */
function retrieveUserAgentProfile() {
  return this.get(`${apiUrl}/agents/me`, 'user');
}

/**
 * Retrieve User's Agent By Username
 *
 */
function retrieveUserAgentProfileByUsername(username) {
  return this.get(`${apiUrl}/agents/username/${username}`, 'user');
}

/**
 * Collection of public user api
 */
const publicAgentApi = secureClient(
  {
    retrieveUserAgentProfile,
    retrieveUserAgentProfileByUsername,
  },
  'xhrPublicAgentApi',
);

export default publicAgentApi;
